import styled from 'styled-components';

/**
 * Styled-component twin of `COMPACT_TOOLTIP_STYLE` (in
 * `src/components/common/tooltipStyles.ts`). The two MUST stay visually
 * in sync — same height, padding, font, border, shadow, etc. — so that
 * styled-component-based sidebar tooltips (Home, Story Manager, Brand
 * Kit, toggle, avatar, etc.) and react-tooltip-based ones using
 * `style={COMPACT_TOOLTIP_STYLE}` look identical to the user.
 *
 * If you change one, change the other.
 */
export const SidebarTooltip = styled.div`
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  /* Lock intrinsic dimensions so the tooltip looks identical no matter
   * which parent button it's nested in (parents like SidebarNavItem cascade
   * font-size: 13px and varying line-heights, which would otherwise leak in). */
  display: inline-flex;
  align-items: center;
  height: 26px;
  box-sizing: border-box;
  background: var(--popover);
  color: var(--popover-foreground);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 0 10px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 1000020;
  border: 1px solid var(--border-subtle);
  box-shadow: var(--elevation-sm);
`;
